import { ErrorList } from '../interfaces/error.interface';

export const Errors: ErrorList = {
  ERR000: {
    code: 'ERR000',
    message: 'auth.errors.login'
  },
  ERR001: {
    code: 'ERR001',
    message: 'auth.errors.login'
  },
  ERR002: {
    code: 'ERR002',
    message: 'errors.codes.ERR002'
  },
  BAD_REQUEST: {
    code: 'BAD_REQUEST',
    message: 'auth.errors.badRequest'
  },
  PS001: {
    code: 'PS001',
    message: 'auth.register.errors.requestTypeNotSupported'
  },
  PS002: {
    code: 'PS002',
    message: 'auth.register.errors.phoneIsNotVerified'
  },
  PS003: {
    code: 'PS003',
    message: 'auth.register.errors.samePasswordError'
  },
  PS004: {
    code: 'PS004',
    message: 'auth.register.errors.username'
  },
  PS005: {
    code: 'PS005',
    message: 'auth.register.errors.email'
  },
  PS006: {
    code: 'PS006',
    message: 'auth.register.errors.termsNotAccepted'
  },
  PS007: {
    code: 'PS007',
    message: 'auth.register.errors.categoryNotSelected'
  },
  CB001: {
    code: 'CB001',
    message: 'errors.codes.CB001'
  },
  CB002: {
    code: 'CB002',
    message: 'errors.codes.CB002'
  },
  CB003: {
    code: 'CB003',
    message: 'errors.codes.CB003'
  },
  CB004: {
    code: 'CB004',
    message: 'errors.codes.CB004'
  },
  CB005: {
    code: 'CB005',
    message: 'errors.codes.CB005'
  },
  CB006: {
    code: 'CB006',
    message: 'errors.codes.CB006'
  },
  CB007: {
    code: 'CB007',
    message: 'errors.codes.CB007'
  },
  CB008: {
    code: 'CB008',
    message: 'errors.codes.CB008'
  },
  HW001: {
    code: 'HW001',
    message: 'errors.codes.HW001'
  },
}